/**
 * API Configuration - Centralized backend URL detection
 * This ensures the app works on both preview and production without manual configuration
 */

const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If no env URL set, use current origin
  if (!envUrl || envUrl === '') {
    return window.location.origin;
  }
  
  try {
    const envHost = new URL(envUrl).hostname;
    const currentHost = window.location.hostname;
    
    // If we're on localhost or the env URL matches current domain, use env URL
    if (currentHost === 'localhost' || 
        currentHost === '127.0.0.1' || 
        envHost === currentHost ||
        currentHost.includes('preview.emergentagent.com')) {
      return envUrl;
    }
    
    // For production (different domain), use current origin
    // This handles cases where the React app is deployed to a different domain
    // than what's in the .env file
    return window.location.origin;
    
  } catch (e) {
    // If URL parsing fails, use current origin
    return window.location.origin;
  }
};

export const API_URL = getBackendUrl();

// Log for debugging
if (typeof window !== 'undefined') {
  console.log('[API Config] Backend URL:', API_URL);
  console.log('[API Config] Current host:', window.location.hostname);
  console.log('[API Config] Env URL:', process.env.REACT_APP_BACKEND_URL || 'not set');
}

export default API_URL;
